import "./src/assets/styles/global.scss";
import React from "react";
import { ThemeProvider } from "./src/context/ThemeContext";
import Layout from "./src/components/layout/layout";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;
